"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.principalRoleActionInputSchema = exports.principalActionInputSchema = exports.principalListSchema = exports.principalSchema = exports.principalRoleRefSchema = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
/**
 * Nutzerkonten und Rollenzuweisung (AC-107).
 *
 * Transportfrei (ADR-04): nur Zod, kein tRPC, kein Prisma, kein NestJS — wie
 * jede andere Datei in diesem Paket.
 *
 * Absichtlich NICHT hier: ein Geltungsbereich fuer eine Rollenzuweisung
 * (Entscheidung E5 dieser Story) und ein Austrittsdatum (Entscheidung E7).
 * Beides waere eine Struktur ohne lesenden Pfad — AC-806 bzw. eine eigene
 * Story bauen sie bei Bedarf an, in ihrer eigenen Migration.
 */
/** Eine zugewiesene Rolle, wie `principals.list` sie zeigt — ohne ihre Rechte. */
exports.principalRoleRefSchema = zod_1.z.strictObject({
    id: common_js_1.uuidSchema,
    slug: zod_1.z.string(),
    name: zod_1.z.string(),
});
/**
 * Ein Konto des Mandanten, wie `principals.list` es ausliefert.
 *
 * `displayName` und `email` kommen aus den geprüften Entra-Ansprüchen `name`
 * und `email` (ersatzweise `preferred_username`) und werden bei JEDER
 * Anmeldung übernommen (`SessionService.create`). Nullable, weil Entra beide
 * nicht garantiert und ein Konto aus dem Entwicklungsmodus (Bearer-Token)
 * keine trägt. `subject` ist der stabile Ankerwert (Entra-`oid`), auf den sich
 * die SBI-IT verlassen kann.
 */
exports.principalSchema = zod_1.z.strictObject({
    id: common_js_1.uuidSchema,
    subject: zod_1.z.string(),
    displayName: zod_1.z.string().nullable(),
    email: zod_1.z.string().nullable(),
    isActive: zod_1.z.boolean(),
    createdAt: zod_1.z.iso.datetime(),
    roles: zod_1.z.array(exports.principalRoleRefSchema),
});
exports.principalListSchema = zod_1.z.array(exports.principalSchema);
/** Kennungen aus der Eingabe laufen über `uuidSchema` (klein normalisiert, Befund zu PR #51). */
/** Eingabe für `principals.lock`/`principals.unlock`. */
exports.principalActionInputSchema = zod_1.z.strictObject({
    principalId: common_js_1.uuidSchema,
});
/** Eingabe für `principals.assignRole`/`principals.revokeRole`. */
exports.principalRoleActionInputSchema = zod_1.z.strictObject({
    principalId: common_js_1.uuidSchema,
    roleId: common_js_1.uuidSchema,
});
//# sourceMappingURL=principals.js.map